import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { CustomerForm } from "@/features/customers/components/customer-form";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Crown } from "lucide-react";
import { useSubscription } from "@/hooks/use-subscription";
import { useCustomers } from "@/features/customers/hooks/use-customers";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(app)/dashboard/customers/new")({
  component: NewCustomerPage,
});

function NewCustomerPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const { data: customers } = useCustomers();
  const { hasReachedLimit, getLimitText } = useSubscription();
  
  const customerCount = customers?.length || 0;
  const hasReachedCustomerLimit = hasReachedLimit('customers', customerCount);

  const handleSuccess = () => {
    navigate({ to: "/dashboard/customers" });
  };

  if (hasReachedCustomerLimit) {
    return (
      <div className="container mx-auto py-6 space-y-6">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate({ to: "/dashboard/customers" })}
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div>
            <h1 className="text-3xl font-bold tracking-tight">Limit erreicht</h1>
            <p className="text-muted-foreground">
              Sie haben das Limit für Kunden erreicht: {getLimitText('customers', customerCount)}
            </p>
          </div>
        </div>
        
        <div className="flex flex-col items-center justify-center py-12 space-y-4">
          <Crown className="h-16 w-16 text-yellow-500" />
          <h2 className="text-xl font-semibold">Upgrade erforderlich</h2>
          <p className="text-muted-foreground text-center max-w-md">
            Um mehr Kunden anzulegen, upgraden Sie bitte auf einen höheren Tarif.
          </p>
          <Button onClick={() => navigate({ to: "/dashboard/settings" })}>
            Zu den Einstellungen
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-6 space-y-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate({ to: "/dashboard/customers" })}
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Neuer Kunde</h1>
          <p className="text-muted-foreground">
            Erstellen Sie einen neuen Kunden ({getLimitText('customers', customerCount)})
          </p>
        </div>
      </div>

      <CustomerForm onSuccess={handleSuccess} />
    </div>
  );
}
